<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },

                    ],
                }"
            />
            
        </section>
        <!-- <div
            class="
                jumbotron
                bg-cover bg-center bg-norepeat
                block
                md:flex
                flex-col
                xl:flex-row
            "
            :style="{
                backgroundImage:
                    'url(' +
                    $i18n.locale +
                    '/images/pages/' +
                    currentPage.slug +
                    '/' +
                    currentPage.images.oImage1.src,
            }"
        >

        </div> -->
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.alt"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl pb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>
                <div class="container-components mb-4 lg:mb-8">
                    <!-- <div class="card"> -->
                    <div class="relative">
                            <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Renaturation d’un ancien bras du Rhin sur l’île de Kembs'
                                ),
                            }"
                            class="-top-4 -right-2"
                        />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Part1_Content.text
                            "
                        ></p>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Part2_Content.text
                            "
                        ></p>
                        
                    <!-- </div>
                    <div class="card"> -->
                        <article-note
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage2.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage2.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],

                                verticalcontent:
                                    currentPage.content.sParagraphTwo_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphTwo_Part1_Content
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-3xl',
                                    content: '',
                                },
                            }"
                        />
                        <article-note
                            :options="{
                                content:
                                    currentPage.content.sParagraphTwo_Part2_Content
                                        .text,

                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-3xl',
                                    content: 'italic',
                                },
                            }"
                        />
                        <article-note
                            :options="{
                                content:
                                    currentPage.content.sParagraphTwo_Part3_Content
                                        .text,

                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-3xl',
                                    content: '',
                                },
                            }"
                        />
                        
                    </div>
                <!-- </div> -->
                <div class="relative mb-4 lg:mb-8">
                    <image-with-descriptions
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage3.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage3.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage3.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />
                </div>

                <div class="container-components">
                    <div class="card">
                        <div class="relative pt-8">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Le chantier de Romanche Gavet, un exemple d'ambition environnementale`
                                    ),
                                }"
                                class="-top-2 right-2"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>

                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphThree_Content.text
                            "
                        ></span>
                        <!-- <Square
                            :options="{
                                from: 'golden_sand',
                                to: 'sushi',
                            }"
                        /> -->
                        <image-with-descriptions
                            class="mt-2"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <article-note style="margin: 0; margin-bottom: 1.25rem;"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                                verticalcontent:
                                    currentPage.content.sParagraphFour_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphFour_Content
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl 2xl:text-3xl',
                                    content: '',
                                },
                            }"
                        />
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Barrage de Livet : renaturation en végétal local'
                                ),
                            }"
                            class="top-2 right-2"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.q10__copyright {
    bottom: 30%;
    position: absolute;
    right: -40%;
    transform: rotate(-90deg);
    font-size: 14px;
}
</style>
